import {createContext} from 'react';

import {User} from '../../types/User';

export interface UserContextType {
  currentUser: User | null;
  userContextLogin: (user: User) => void;
  userContextLogout: () => void;
  isUserLoggedIn: () => boolean;
  isLoading: boolean;
  isContractSigned: boolean;
  isRoleCompany: boolean;
}

const defaultValue = {} as UserContextType;
const UserContext = createContext<UserContextType>(defaultValue);
UserContext.displayName = 'UserContext';

export {UserContext};
